import 'jspdf-autotable'
import jsPDF from 'jspdf'
import * as XLSX from 'xlsx-js-style'
import {saveAs} from 'file-saver'

declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: any) => jsPDF
  }
}

interface TableColumn {
  title: string
  key: string
}

// Define AutoTableOptions type
interface AutoTableOptions {
  startY?: number
  head?: (string | string[])[]
  body?: (string | number)[][]
  data?: unknown[] // Array of objects
  fileName?: string
}

export const downloadCSV = (data: any, filename: string) => {
  // Extracting keys from the first object in jsonData
  const keys = Object.keys(data[0])

  console.log(Object.keys(data))

  console.log(keys)

  // Creating CSV content with headers
  let csvContent = keys.join(',') + '\n'
  csvContent += data.map((row: any) => keys.map((key) => row[key]).join(',')).join('\n')

  // Creating a data URI
  const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent)

  // Creating a link element to trigger the download
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${filename}.csv`)
  document.body.appendChild(link)
  link.click()
}

export const downloadPDF = async (options: any) => {
  try {
    const {data, fileName, startY} = options

    // Ensure data exists and has at least one item
    if (!data || data.length === 0) {
      throw new Error('Data is empty or undefined')
    }

    // Assert the type of data as an array of objects
    const dataArray = data as object[]
    if (!dataArray[0]) {
      throw new Error('Data is empty')
    }

    // Extract columns dynamically from the first item in the data array
    const columns: TableColumn[] = Object.keys(dataArray[0]).map((key) => ({
      title: key,
      key: key,
    }))

    // Generate PDF
    const doc = new jsPDF()
    doc.text(fileName!, 10, 10)

    const head = columns.map((column) => column.title)
    const body = dataArray.map((item) =>
      columns.map((column) => String((item as never)[column.key]))
    )

    doc.autoTable({
      startY: startY || 20,
      head: [head],
      body: body,
      theme: 'grid', // Change table theme to 'grid'
      styles: {
        fontSize: 10, // Set font size to 10
        cellPadding: 2, // Set cell padding to 2
      },
      columnStyles: {0: {cellWidth: '50px'}}, // Set the width of the first column to 'auto'
      margin: {top: 20}, // Set margin top to 20
    })

    // Download PDF
    doc.save(`${fileName}.pdf`)
  } catch (error) {
    console.error('Error generating PDF:', error)
  }
}

export const convertToTwoWords = (str: string) => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const handleSampleDownload = <T extends Record<string, any>>(
  content: T[],
  filename: string
) => {
  const twoWordsDownloadContent = content.map((item: any) => {
    const newItem: Record<string, any> = {}
    for (const key in item) {
      newItem[convertToTwoWords(key)] = item[key]
    }
    return newItem
  })

  const worksheet = XLSX.utils.json_to_sheet(twoWordsDownloadContent)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  // Buffer to store the generated Excel file
  const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  })

  saveAs(blob, `${filename}.xlsx`)
}

// DID NOT FOCUS TOO MUCH ON THAT FUNCTION //
export const downloadAsCSV = <T extends object>(data: T[], filename: string): void => {
  if (!data.length) return

  const keys = Object.keys(data[0]) as (keyof T)[]

  const escapeCSVValue = (value: unknown): string => {
    if (value === null || value === undefined) {
      return ''
    }

    const stringValue = String(value).replace(/"/g, '""')

    return /[",\n\r]/.test(stringValue) ? `"${stringValue}"` : stringValue
  }

  const csvContent = [
    keys.map(String).join(','),
    ...data.map((row) => keys.map((key) => escapeCSVValue(row[key])).join(',')),
  ].join('\n')

  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;',
  })

  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `${filename}.csv`

  document.body.appendChild(link)
  link.click()
  link.remove()

  URL.revokeObjectURL(url)
}

export interface IDownloadRechargeData {
  username: string
  rechargedate: string
  paymentmethod: string
  type: string
  note: string
  balance: number
}

const headerLabels: Record<keyof IDownloadRechargeData, string> = {
  username: 'Username',
  rechargedate: 'Recharge Date',
  paymentmethod: 'Payment Method',
  type: 'Type',
  note: 'Note',
  balance: 'Balance',
}

export const formateDataRecharge = (data: any) => {
  const formattedData: IDownloadRechargeData[] = []

  data.map((singleItem: any, index: number) => {
    const singleData: IDownloadRechargeData = {
      username: singleItem.userInformation.username,
      rechargedate: singleItem.rechargedate,
      paymentmethod: singleItem.paymentmethod,
      type: singleItem.type,
      note: singleItem.note,
      balance: singleItem.balance,
    }
    formattedData.push(singleData)
    return formattedData
  })

  return formattedData
}

const cleanText = (value: unknown): string => {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value)
    .replace(/<br\s*\/?>/gi, '\n')
    .trim()
}

const formatRechargeDate = (value: string): Date | string => {
  if (!value) {
    return ''
  }

  const date = new Date(value)

  return Number.isNaN(date.getTime()) ? value : date
}

const formatType = (value: unknown): string => {
  const type = cleanText(value).toLowerCase()

  const typeMap: Record<string, string> = {
    deposite: 'Deposit',
    deposit: 'Deposit',
    withdraw: 'Withdrawal',
    withdrawal: 'Withdrawal',
  }

  return typeMap[type] ?? type
}

export const downloadAsExcel = (data: IDownloadRechargeData[], filename: string): void => {
  if (!data.length) {
    return
  }

  const excelData = data.map((row) => ({
    [headerLabels.username]: cleanText(row.username),

    [headerLabels.rechargedate]: formatRechargeDate(row.rechargedate),

    [headerLabels.paymentmethod]: cleanText(row.paymentmethod),

    [headerLabels.type]: formatType(row.type),

    [headerLabels.note]: cleanText(row.note),

    [headerLabels.balance]:
      row.balance === null || row.balance === undefined ? '' : Number(row.balance),
  }))

  const worksheet = XLSX.utils.json_to_sheet(excelData)

  const range = XLSX.utils.decode_range(worksheet['!ref'] ?? 'A1')

  /**
   * Automatically calculate column widths
   *
   * Minimum width: 10
   * Maximum width: 50
   */
  worksheet['!cols'] = Array.from({length: range.e.c + 1}, (_, columnIndex) => {
    let maxLength = 0

    for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex++) {
      const cellAddress = XLSX.utils.encode_cell({
        r: rowIndex,
        c: columnIndex,
      })

      const cell = worksheet[cellAddress]

      if (!cell) {
        continue
      }

      const value = cell.v

      if (value === null || value === undefined) {
        continue
      }

      const length = String(value).length

      maxLength = Math.max(maxLength, length)
    }

    return {
      wch: Math.min(Math.max(maxLength + 2, 10), 50),
    }
  })

  /**
   * Format Recharge Date
   *
   * Column B
   */
  for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex++) {
    const cellAddress = XLSX.utils.encode_cell({
      r: rowIndex,
      c: 1,
    })

    const cell = worksheet[cellAddress]

    if (cell) {
      cell.z = 'dd-mmm-yyyy hh:mm AM/PM'
    }
  }

  /**
   * Format Balance
   *
   * Column F
   */
  for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex++) {
    const cellAddress = XLSX.utils.encode_cell({
      r: rowIndex,
      c: 5,
    })

    const cell = worksheet[cellAddress]

    if (cell) {
      cell.z = '#,##0.00'
    }
  }

  /**
   * Header style
   *
   * Note: standard `xlsx` doesn't reliably preserve
   * cell styles when writing the file.
   */
  for (let columnIndex = range.s.c; columnIndex <= range.e.c; columnIndex++) {
    const cellAddress = XLSX.utils.encode_cell({
      r: 0,
      c: columnIndex,
    })

    const cell = worksheet[cellAddress]

    if (cell) {
      cell.s = {
        font: {
          bold: true,
        },
      }
    }
  }

  /**
   * Wrap Note column
   *
   * Column E
   */
  for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex++) {
    const cellAddress = XLSX.utils.encode_cell({
      r: rowIndex,
      c: 4,
    })

    const cell = worksheet[cellAddress]

    if (cell) {
      cell.s = {
        alignment: {
          vertical: 'top',
          wrapText: true,
        },
      }
    }
  }

  /**
   * Freeze header row
   */
  worksheet['!freeze'] = {
    xSplit: 0,
    ySplit: 1,
  }

  /**
   * Enable filter
   */
  worksheet['!autofilter'] = {
    ref: worksheet['!ref'] ?? 'A1',
  }

  worksheet['A1'].s = {
    font: {
      bold: true,
    },
  }

  const workbook = XLSX.utils.book_new()

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Recharge Report')

  XLSX.writeFile(workbook, `${filename}.xlsx`)
}
